module.exports = require("vue-progressbar");